import { CLASSROOM_MODULE_REVERT } from '../actions';
import { revertToVersion } from '../api';
import * as classRoomSelectors from '../../selectors/classroom';
import * as materialsSelectors from '../selectors';

const revertAction = (status, payload) => ({
  type: CLASSROOM_MODULE_REVERT,
  status,
  payload,
});

const revertStarted = revertAction.bind(null, 'started');
const revertSuccess = revertAction.bind(null, 'success');
const revertError = revertAction.bind(null, 'error');

const revert = (version) => async (dispatch, getState) => {
  const state = getState();
  const classRoom = classRoomSelectors.currentClassRoomId(state);
  const section = materialsSelectors.currentSection(state);
  const startedPayload = { classRoom, section, version: version.id };

  dispatch(revertStarted(startedPayload));

  try {
    const updatedSection = await revertToVersion(
      classRoom,
      section.id,
      version.id
    );

    const successPayload = {
      classRoom,
      section: updatedSection,
      version: updatedSection.version,
    };
    dispatch(revertSuccess(successPayload));
  } catch (error) {
    dispatch(revertError(error));
  }
};

export default revert;
